let burguer = document.querySelector('.burguer');
let menu = document.querySelector('.header .mobile');
burguer.addEventListener('click', function(e){
  this.classList.add('opacity');
  close.classList.remove('opacity');
  menu.style.transform="translateX(0)"
})

let close = document.querySelector('.close');
close.addEventListener('click', function(e){
  this.classList.add('opacity');
  burguer.classList.remove('opacity');
  menu.style.transform="translateX(100%)"
})


let overlay = document.querySelector('.overlay-mobile');

overlay.addEventListener('click', function (e) {
  if (!e.target.closest('.mobile')) {
    close.classList.add('opacity');
    burguer.classList.remove('opacity');
    menu.style.transform = "translateX(100%)";
    this.classList.remove('active');
  }
});
